import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { I18nService } from 'app/core/services/i18n/i18n.service';
import { CustomWindowService } from 'app/core/services/custom-window-service/custom-window.service';
import { IAppState } from 'app/modules/shared-area/root-state';
import { ReferencesService } from 'app/core/services/references/references.service';
import { ReferencesDialogComponent } from '../../references-dialog.component';
import * as ReferencesActions from './references.actions';
import * as ReferencesSelectors from './references.selectors';

@Injectable()
export class ReferencesEffects {
  showReferences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReferencesActions.showReferences),
      tap(() => {
        this.windowService.open({
          title: this.i18n.getLocalizedString('dialog.references.title'),
          content: ReferencesDialogComponent,
          width: 750
        });
      }),
      map(action => action.id),
      switchMap(id =>
        this.referencesService.getReferences(id, 0, 200).pipe(
          map(references => ReferencesActions.showReferencesSuccess({ result: references })),
          // catchError((error) => of(ReferencesActions.showReferencesError({ error }))),
        ),
      ),
    )
  );

  loadMore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReferencesActions.loadMore),
      withLatestFrom(
        this.store.pipe(select(ReferencesSelectors.getId)), 
        this.store.pipe(select(ReferencesSelectors.getReferences))
      ),
      switchMap(([, id, currentReferencesResult]) =>
        this.referencesService
          .getReferences(id, currentReferencesResult.references.length, 200)
          .pipe(map(references => ReferencesActions.loadMoreSuccess({ result: references }))),
      ),
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<IAppState>,
    private i18n: I18nService,
    private windowService: CustomWindowService,
    private referencesService: ReferencesService,
  ) {}
}
